<template>
  <div class="pa-6">
    <Loader :messageSelector="messageSelector" :overlay="overlay" />

    <v-form ref="form" v-model="valid">
      <fieldset>
        <legend class="text-h6 text-sm-h5">Assurance</legend>
        <RessourceInfoBulle code="RE-ASS-1" />

        <v-autocomplete
          v-model="statutEmploi.assurance"
          :item-text="itemText"
          :item-value="itemValue"
          :items="getAssurances"
          :rules="rules.assurance"
          class="cssRequired"
          label="Assurance"
          required
          return-object
          @change="assuranceChange"
        ></v-autocomplete>

        <div v-if="isAssurance">
          <v-radio-group v-model="choixJustificatifAssurance">
            <v-radio
              v-for="n in textesAssurances.length"
              :key="n"
              :value="n"
              class="mb-4 text-justify"
              @change="updateChoix(textesAssurances[n - 1].propertyName)"
            >
              <template v-slot:label>
                <div class="ml-4" v-html="textesAssurances[n - 1].texte" />
              </template>
            </v-radio>

            <v-input :rules="rules.justificatifAssurance" />
          </v-radio-group>

          <!-- affichage d'un lien clickable pour les cas 8 et 9 -->
          <div v-if="choixJustificatifAssurance === 8 || choixJustificatifAssurance === 9" class="mb-10">
            <RessourceInfoBulle code="RE-ASS-2" />
          </div>
          <v-checkbox
            v-if="isTsOuTcfStatutMembreOuAutoriseASInscrire"
            v-model="statutEmploi.validationAssurance"
            :rules="rules.validationAssurance"
            @change="validateForm(false)"
            class="cssRequired"
            color="primary"
            required
          >
            <template v-slot:label>
              En cliquant ici, je déclare que les informations ci-dessus sont exactes et je m'engage à aviser sans délai le secrétaire de
              l'Ordre de tout changement modifiant de quelque façon la cause de mon exemption d'adhérer au contrat du régime collectif
              d'assurance de la responsabilité professionnelle de l'Ordre.
            </template>
          </v-checkbox>
        </div>
      </fieldset>
    </v-form>

    <div class="text-center mt-6 d-flex justify-space-between">
      <v-btn color="primary" @click="back()">Retour</v-btn>
      <v-btn :disabled="!valid" color="primary" @click="saveAndContinue()">Suivant</v-btn>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
import Loader from "../Loader"
import { isTsOuTcfStatutMembreOuAutoriseASInscrire } from "@/utils/autorisationHelper"
import NavigationPageFormulaireInscriptionMixin from "@/mixins/navigationPageFormulaireInscriptionMixin"

// page isDroitsAcquis === false
export default {
  mixins: [NavigationPageFormulaireInscriptionMixin],
  props: {
    routeName: {
      type: String,
      default: "",
    },
  },
  components: {
    Loader: Loader,
  },
  data() {
    return {
      overlay: false,
      messageSelector: "",
      valid: true,
      choixJustificatifAssurance: null,
      textesAssurances: [
        {
          propertyName: "choix1",
          texte:
            "<span class='font-weight-medium'>1 - Je <span class='font-weight-black'>n'exerce pas la profession</span>, ni n'exerce en aucune façon les activités professionnelles mentionnées au paragraphe d de l'article 37 du Code des professions (L.R.Q., c. C-26) [Pour un thérapeute conjugal et familial: je n'exerce pas la profession, ni n'exerce en aucune façon les activités professionnelles mentionnées que je peux exercer, en outre de celles qui me sont autrement permises par la loi];</span>",
        },
        {
          propertyName: "choix2",
          texte:
            "<span class='font-weight-medium'>2 - Je poursuis à temps plein et de façon exclusive des <span class='font-weight-black'>études universitaires</span> de deuxième ou de troisième cycle se rapportant au travail social [Pour un thérapeute conjugal ou familial: je poursuis à temps plein et de facon exclusive des études universitaires de deuxième ou de troisième cycle se rapportant à la thérapie conjugale et familiale];</span>",
        },
        {
          propertyName: "choix3",
          texte:
            "<span class='font-weight-medium'>3 - Je suis au service exclusif de Santé Québec ou d'un établissement au sens de la Loi sur la gouvernance du système de santé et de services sociaux, de la Loi sur les services de santé et les services sociaux pour les Inuits et les Naskapis ou de la Loi sur les services de santé et les services sociaux pour les autochtones cris;</span>",
        },
        {
          propertyName: "choix4",
          texte:
            "<span class='font-weight-medium'>4 - Je suis au service exclusif d'une <span class='font-weight-black'>commission scolaire / un centre de services scolaire</span> du Québec;</span>",
        },
        {
          propertyName: "choix5",
          texte:
            "<span class='font-weight-medium'>5 - Je suis au service exclusif du <span class='font-weight-black'>gouvernement du Québec</span> et nommé ou rémunéré suivant la Loi sur la <span class='font-weight-black'>fonction publique</span> (L.R.Q., c. F-3.1.1);</span>",
        },
        {
          propertyName: "choix6",
          texte:
            "<span class='font-weight-medium'>6 - Je suis au service exclusif d'un organisme dont le <span class='font-weight-black'>gouvernement du Québec</span> ou l'un de ses ministres nomme la majorité des membres, dont la loi ordonne que le personnel soit nommé ou rémunéré suivant la Loi sur la fonction publique ou dont le fonds social fait partie du domaine public, ou d'un organisme mandataire du gouvernement et désigné comme tel dans la loi;</span>",
        },
        {
          propertyName: "choix7",
          texte:
            "<span class='font-weight-medium'>7 - Je suis au service exclusif (rémunéré par) de la <span class='font-weight-black'>fonction publique du Canada</span>, des <span class='font-weight-black'>Forces canadiennes</span> ou d'une société d'État au sens de la loi Fédérale;</span>",
        },
        {
          propertyName: "choix8",
          texte:
            "<span class='font-weight-medium'>8 - Je suis au service exclusif d'une personne physique ou d'une personne morale <span class='font-weight-black'>autre que celles visées au paragraphe 3° à 7°</span> et j'ai déposé auprès du secrétaire de l'Ordre un certificat attestant que cette personne se porte garante, prend fait et cause et répond financièrement des conséquences de toute faute ou négligence commise par moi dans l'exercice de ma profession, avec une garantie comportant les stipulations minimales prescrites à l'article 4 du Règlement sur l'assurance de la responsabilité professionnelles des membres de l'Ordre des travailleurs sociaux et des thérapeutes conjugaux et familiaux du Québec;</span>",
        },
        {
          propertyName: "choix9",
          texte:
            "<span class='font-weight-medium'>9 - Je suis au service, d'une manière exclusive, d'une ou de plusieurs des personnes visées aux paragraphes 3° à 8° et, dans le cas où l'une de ces personnes est celle visée au paragraphe 8°, j'ai déposé, auprès du secrétaire de l'Ordre, un certificat attestant que cette personne se porte garante, prend fait et cause et répond financièrement des conséquences de toute faute ou négligence commise par moi dans l'exercice de ma profession, avec une garantie comportant les stipulations minimales prescrites à l'article 4 du Règlement sur l'assurance de la responsabilité professionnelle des membres de l'Ordre des travailleurs sociaux et des thérapeutes conjugaux et familiaux du Québec.</span>",
        },
      ],
      rules: {
        validationAssurance: [(v) => !!v || "La validation d'assurance est requise"],
        assurance: [(v) => !!v || "Le champ assurance est requis"],
        justificatifAssurance: [
          () => !this.isAssurance || !!this.choixJustificatifAssurance || "Au moins un choix de justification est requis",
        ],
      },
    }
  },
  computed: {
    ...mapGetters({
      demandeInscriptionId: "DemandeInscription/GET_DEMANDEINSCRIPTIONID",
      statutEmploi: "StatutEmploi/getStatutEmploi",
      autorisations: "AutorisationDePratique/GET_AUTORISATIONSDEPRATIQUE",
      getAssurances: "Catalogue/getAssurances",
    }),
    isTsOuTcfStatutMembreOuAutoriseASInscrire() {
      return isTsOuTcfStatutMembreOuAutoriseASInscrire(this.autorisations)
    },
    isAssurance() {
      return (
        this.statutEmploi.assurance &&
        (this.statutEmploi.assurance.id === this.$catalogues.assurance.exemption ||
          this.statutEmploi.assurance.id === this.$catalogues.assurance.complementaire)
      )
    },
  },
  created() {
    this.fetchItems()
  },
  methods: {
    ...mapMutations({
      updateStateChoix: "StatutEmploi/updateStateChoix",
    }),
    ...mapActions({
      getCatalogue: "Catalogue/getCatalogue",
      getStatutEmploiByDemandeInscriptionId: "StatutEmploi/getStatutEmploiByDemandeInscriptionId",
      updateStatutEmploi: "StatutEmploi/updateStatutEmploi",
      getAutorisationDePratiqueByDemandeInscriptionId: "AutorisationDePratique/getAutorisationDePratiqueByDemandeInscriptionId",
    }),
    async fetchItems() {
      try {
        this.messageSelector = "Loading"
        this.overlay = true

        const requests = [this.getCatalogue(this.$cataloguesDesc.assurance)]

        if (this.demandeInscriptionId) {
          requests.push(this.getStatutEmploiByDemandeInscriptionId(this.demandeInscriptionId))
          requests.push(this.getAutorisationDePratiqueByDemandeInscriptionId(this.demandeInscriptionId))
        }

        await Promise.all(requests)

        this.initialiseChoix()
        this.validateForm(false)

        this.overlay = false
      } catch (erreur) {
        console.log(erreur)
      }
    },
    saveAndContinue() {
      this.save()
    },
    async save() {
      this.messageSelector = "Save"
      this.overlay = true
      this.validateForm()

      if (this.valid) {
        try {
          await this.updateStatutEmploi(this.statutEmploi)
          this.overlay = false
          this.next()
        } catch (err) {
          console.log(err)
        }
      }
      this.overlay = false
    },
    validateForm(resetValidation = false) {
      this.valid = this.$refs.form?.validate() || false

      if (resetValidation) {
        this.$refs.form?.resetValidation()
      }
    },
    itemText: (item) => item.lang00,
    itemValue: (item) => item.id,
    /// Initialise la valeur de this.choixJustificatifAssurance, depuis this.statutEmploi.choix{N}
    initialiseChoix() {
      Object.keys(this.statutEmploi)
        .filter((property) => this.textesAssurances.some((t) => t.propertyName === property))
        .filter((property) => this.statutEmploi[property])
        .forEach((property) => {
          const matches = /[0-9]+/.exec(property)

          if (matches.length) {
            this.choixJustificatifAssurance = parseInt(matches[0])
          }
        })

      this.validateForm(true)
    },
    /// Synchronise this.choixJustificatifAssurance vers this.statutEmploi.choix{N}
    updateChoix(propertyUpdated) {
      Object.keys(this.statutEmploi)
        .filter((property) => this.textesAssurances.some((t) => t.propertyName === property))
        .forEach((property) => {
          this.updateStateChoix({ field: property, choix: property === propertyUpdated })
        })

      this.validateForm(true)
    },
    assuranceChange() {
      this.statutEmploi.choix1 = null
      this.statutEmploi.choix2 = null
      this.statutEmploi.choix3 = null
      this.statutEmploi.choix4 = null
      this.statutEmploi.choix5 = null
      this.statutEmploi.choix6 = null
      this.statutEmploi.choix7 = null
      this.statutEmploi.choix8 = null
      this.statutEmploi.choix9 = null
      this.statutEmploi.validationAssurance = null

      this.choixJustificatifAssurance = null
      this.validateForm(true)
    },
  },
}
</script>

<style></style>